export const manager = {
  seo: {
    title: 'Gérez votre restaurant en ligne avec Bistroo Manager | Bistroo',
    description: "Gérez menus, horaires, promotions et paiements depuis une seule application. Le Bistroo Manager pour les restaurants et les professionnels de la restauration.",
  },
  hero: {
    title: {
      pt1: 'Un',
      pt2: 'gestionnaire en ligne',
      pt3: 'pour garder les rênes en main',
    },
    description:
      'Avec l\'application Bistroo Manager, vous pouvez tout modifier dans votre boutique en quelques secondes seulement. Traitez chaque commande sans effort et restez toujours le chef dans votre restaurant en ligne.',
    button: 'Découvrir le Manager',
  },
  paragraphs: {
    paragraph_1: {
      title: 'Contrôle en temps réel de votre boutique en ligne',
      text: 'Maintenez une expérience client parfaite. Ajustez tous vos paramètres en temps réel via le Bistroo Manager. Accessible sur tous vos appareils, depuis n\'importe quel endroit.',
      cta: 'Explorer les formules Bistroo',
    },
    paragraph_2: {
      title: 'Paramètres de livraison parfaits',
      text: 'Adaptez parfaitement vos zones de livraison à vos capacités du jour et dessinez vos zones souhaitées avec précision sur Google Maps. Avec la possibilité d\'adapter vos conditions par zone de livraison.',
      cta: '',
    },
    paragraph_3: {
      title: 'Insights & Rapports',
      text: 'Des insights avancés et des rapports sont disponibles via l\'application Manager. Adaptez vos conditions sur la base de décisions fondées sur les données et de suggestions du Manager.',
      cta: 'Explorer les formules Bistroo',
    },
    paragraph_4: {
      title: 'Rationalisez vos processus',
      text: 'Économisez un temps précieux et du travail manuel, sans jamais être surpris par trop de commandes ou un trafic en ligne inattendu ! Ajustez facilement votre volume aux heures de pointe et vos délais de livraison estimés en un seul clic. Gardez le contrôle en tout temps.',
      cta: '',
    },
  },
  key_features: {
    cards: {
      card_1: {
        title: 'Modifiez facilement votre menu et vos paramètres.',
        text: 'Modifiez le menu et les paramètres de votre restaurant depuis n\'importe quel endroit. Accédez depuis n\'importe quel appareil, à tout moment, et modifiez facilement les produits, les prix, les stocks, les remises, les promotions et les zones de livraison.',
        button: '',
        img_alt: '',
      },
      card_2: {
        title: 'Intégrations.',
        text: 'Connectez votre système de caisse ou vos outils externes préférés.',
        button: '',
        img_alt: '',
      },
      card_3: {
        title: 'Gérez plusieurs établissements.',
        text: 'Gérez facilement plusieurs établissements, si cela s\'applique à votre entreprise.',
        button: '',
        img_alt: '',
      },
      card_4: {
        title: 'Suivez vos paiements.',
        text: 'Ou traitez des remboursements. Le taux de remboursement moyen n\'est cependant que de 0,2 %.',
        button: '',
        img_alt: '',
      },
      card_5: {
        title: 'Rapports & Analyses.',
        text: 'Analysez vos performances en ligne avec des options de rapports de base et avancés.',
        button: '',
        img_alt: '',
      },
    },
  },
  testimonial: {
    text: '"Le Manager est constamment renouvelé, c\'est agréable de voir et de vivre l\'évolution."',
    cta: 'Lire l\'histoire complète',
    name: 'Istanbul Grillroom',
    job_title: 'Grillroom',
  },
  faq: {
    title_pt1: 'Tout sur le',
    title_pt2: 'Bistroo Manager',
    items: [
      { q: 'Qu\'est-ce que l\'application Bistroo Manager ?', a: 'Le Bistroo Manager est l\'outil de gestion central de votre restaurant en ligne. Il vous permet de modifier le menu, de gérer les commandes, de définir les zones de livraison, de consulter les rapports et de tout suivre, depuis n\'importe quel appareil.' },
      { q: 'Sur quels appareils fonctionne l\'application Manager ?', a: 'L\'application Manager fonctionne sur smartphone, tablette et bureau via le navigateur. Vous y avez accès partout tant que vous avez une connexion internet, pratique même si vous n\'êtes pas dans l\'établissement.' },
      { q: 'Comment modifier mon menu via le Manager ?', a: 'Accédez à la section menu dans le Manager, sélectionnez un produit ou une catégorie et modifiez le prix, la description, la photo ou la disponibilité. La modification est immédiatement en ligne sur votre boutique, votre borne et votre boutique QR.' },
      { q: 'Puis-je gérer plusieurs établissements via un seul compte ?', a: 'Oui. Via le Manager, vous gérez plusieurs établissements depuis un seul tableau de bord. Pour chaque établissement, vous configurez des menus, des horaires d\'ouverture et des zones de livraison séparés.' },
      { q: 'Comment définir les zones et frais de livraison ?', a: 'Tracez précisément vos zones de livraison sur Google Maps dans le Manager. Par zone, vous définissez les frais de livraison, les montants minimum de commande et la disponibilité. Les modifications sont immédiatement actives.' },
      { q: 'Comment consulter mes rapports de chiffre d\'affaires ?', a: 'Dans le Manager, sous Rapports, vous trouverez un aperçu du chiffre d\'affaires par jour, semaine ou mois. Vous voyez vos produits les plus vendus, les valeurs moyennes des commandes et les tendances qui vous aident à prendre de meilleures décisions.' },
      { q: 'Puis-je modifier les horaires d\'ouverture en temps réel ?', a: 'Oui. Fermez votre boutique en un clic pour un jour de congé imprévu, ajustez temporairement vos heures de pointe ou ouvrez des créneaux supplémentaires les jours chargés. Tout immédiatement, sans intervention de Bistroo.' },
      { q: 'Comment traiter les remboursements via le Manager ?', a: 'Accédez à la commande concernée dans l\'aperçu des commandes et choisissez Remboursement. Le montant est immédiatement recrédité sur le compte de paiement du client. Le taux de remboursement moyen chez les clients Bistroo n\'est que de 0,2 %.' },
      { q: 'Y a-t-il des notifications push pour les nouvelles commandes ?', a: 'Oui. L\'application Manager envoie immédiatement une notification push pour chaque nouvelle commande. Vous ne manquez ainsi jamais une commande, même si vous n\'êtes pas devant l\'écran.' },
      { q: 'Quel est le coût du Bistroo Manager ?', a: 'L\'application Manager est incluse dans chaque formule Bistroo, y compris la formule gratuite. Vous avez toujours le contrôle total de votre restaurant sans frais supplémentaires.' },
    ],
  },
}
